import { useUser } from '@/hooks/useSwr';

export const UPDATE_EMAIL_KEY = 'updating_email';

// Email change notification logic:
// 1. new_email: Set by Supabase when user initiates email change. Cleared on successful update.
// 2. updating_email: Custom metadata flag. Set on initiation, cleared on user cancellation.
// 3. Notification shown only when both flags are true.
// 4. No direct API to cancel email change on Supabase; our UI offers a "cancel" option.

export function useShowEmailChange() {
  const { data } = useUser();

  if (UPDATE_EMAIL_KEY in (data?.data.user?.user_metadata ?? {})) {
    return Boolean(
      data?.data.user?.user_metadata.updating_email &&
        data?.data.user?.new_email
    );
  }
  return Boolean(data?.data.user?.new_email);
}
